import { z } from '@harvestiq/zod';
import { entityHistorySchema } from '../entities-history/entity-history';
import { dbPolicySchema } from './db-policy';
import { dbPolicyCoverageSchema } from '../policy-coverages/db-policy-coverage';

export const policySchema = dbPolicySchema.extend({
  // TODO: All policies should have an entity but can't be guaranteed as entityId is nullable in DB
  entityHistory: entityHistorySchema.nullable(),
  endorsementCount: z.number(),
  policyCoverages: dbPolicyCoverageSchema.array(),
  entityId: z.string().nullable(),
  evergreenSigningAgentId: z.string().nullable(),
});

export type Policy = z.infer<typeof policySchema>;
